import React, { useEffect, useRef, useState } from 'react';

const CDN = 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons';

const SKILLS = [
  {
    category: 'Languages',
    items: [
      { name: 'Java',       src: `${CDN}/java/java-original.svg` },
      { name: 'Python',     src: `${CDN}/python/python-original.svg` },
      { name: 'JavaScript', src: `${CDN}/javascript/javascript-original.svg` },
      { name: 'TypeScript', src: `${CDN}/typescript/typescript-original.svg` },
      { name: 'C++',        src: `${CDN}/cplusplus/cplusplus-original.svg` },
    ],
  },
  {
    category: 'Frontend',
    items: [
      { name: 'React',         src: `${CDN}/react/react-original.svg` },
      { name: 'Next.js',       src: `${CDN}/nextjs/nextjs-original.svg`, invert: true },
      { name: 'Redux',         src: `${CDN}/redux/redux-original.svg` },
      { name: 'TypeScript',    src: `${CDN}/typescript/typescript-original.svg` },
      { name: 'Tailwind CSS',  src: `${CDN}/tailwindcss/tailwindcss-original.svg` },
      { name: 'HTML5',         src: `${CDN}/html5/html5-original.svg` },
      { name: 'CSS3',          src: `${CDN}/css3/css3-original.svg` },
      { name: 'Vite',          src: `${CDN}/vitejs/vitejs-original.svg` },
      { name: 'Framer Motion', src: `${CDN}/framermotion/framermotion-original.svg` },
    ],
  },
  {
    category: 'Backend',
    items: [
      { name: 'Node.js',          src: `${CDN}/nodejs/nodejs-original.svg` },
      { name: 'Express',          src: `${CDN}/express/express-original.svg`, invert: true },
      { name: 'Java 21',          src: `${CDN}/java/java-original.svg` },
      { name: 'Spring Boot',      src: `${CDN}/spring/spring-original.svg` },
      { name: 'Spring Security',  src: `${CDN}/spring/spring-original.svg` },
      { name: 'FastAPI',          src: 'https://cdn.simpleicons.org/fastapi/009688' },
      { name: 'Docker',           src: `${CDN}/docker/docker-original.svg` },
      { name: 'RabbitMQ',         src: `${CDN}/rabbitmq/rabbitmq-original.svg` },
      { name: 'Redis',            src: `${CDN}/redis/redis-original.svg` },
      { name: 'REST APIs',        fallback: { bg: '#1a2a44', text: 'API', color: '#D4A843' } },
      { name: 'JWT',              fallback: { bg: '#000',    text: 'JWT', color: '#fb015b' } },
    ],
  },
  {
    category: 'Databases',
    items: [
      { name: 'PostgreSQL', src: `${CDN}/postgresql/postgresql-original.svg` },
      { name: 'MySQL 8',    src: `${CDN}/mysql/mysql-original.svg` },
      { name: 'MongoDB',    src: `${CDN}/mongodb/mongodb-original.svg` },
      { name: 'Supabase',   src: `${CDN}/supabase/supabase-original.svg` },
      { name: 'Firebase',   src: `${CDN}/firebase/firebase-plain.svg` },
      { name: 'Qdrant',     src: 'https://cdn.simpleicons.org/qdrant/DC244C' },
    ],
  },
  {
    category: 'AI / ML',
    items: [
      { name: 'LangGraph',  fallback: { bg: '#1C3C3C', text: 'LG',  color: '#00D4AA' } },
      { name: 'Groq API',   fallback: { bg: '#111',    text: 'GQ',  color: '#fff' } },
      { name: 'TensorFlow', src: `${CDN}/tensorflow/tensorflow-original.svg` },
      { name: 'OpenCV',     src: `${CDN}/opencv/opencv-original.svg` },
      { name: 'Python',     src: `${CDN}/python/python-original.svg` },
      { name: 'Flask',      src: `${CDN}/flask/flask-original.svg`, invert: true },
      { name: 'CNN',        fallback: { bg: '#5c3ee8', text: 'CNN', color: '#fff' } },
    ],
  },
  {
    category: 'Tools & Platforms',
    items: [
      { name: 'Git',     src: `${CDN}/git/git-original.svg` },
      { name: 'GitHub',  src: `${CDN}/github/github-original.svg`, invert: true },
      { name: 'Postman', src: `${CDN}/postman/postman-original.svg` },
      { name: 'Netlify', src: `${CDN}/netlify/netlify-original.svg` },
      { name: 'Vercel',  fallback: { bg: '#000',    text: '▲',  color: '#fff' } },
      { name: 'Render',  src: 'https://cdn.simpleicons.org/render/46E3B7' },
      { name: 'CI/CD',   fallback: { bg: '#222',    text: 'CD', color: '#aaa' } },
      { name: 'Agile',   fallback: { bg: '#0052cc', text: 'AG', color: '#fff' } },
    ],
  },
];

function SkillItem({ item, animate, delay, dark }) {
  const [err, setErr] = useState(false);
  const showFallback = item.fallback || err;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
        padding: '14px 10px',
        borderRadius: 10,
        cursor: 'default',
        opacity: animate ? 1 : 0,
        transform: animate ? 'translateY(0)' : 'translateY(12px)',
        transition: `opacity 0.4s ease ${delay}s, transform 0.4s ease ${delay}s, background 0.2s`,
        minWidth: 68,
      }}
      onMouseEnter={e => {
        e.currentTarget.style.background = 'var(--accent-glow)';
        e.currentTarget.style.transform = 'translateY(-3px)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.background = 'transparent';
        e.currentTarget.style.transform = 'translateY(0)';
      }}
    >
      {showFallback ? (
        <svg width="36" height="36" viewBox="0 0 36 36">
          <rect width="36" height="36" rx="7" fill={item.fallback?.bg || '#333'} />
          <text x="18" y="18" textAnchor="middle" dominantBaseline="central"
            fontSize={item.fallback?.text?.length > 2 ? 9 : 13}
            fontWeight="700" fill={item.fallback?.color || '#fff'}
            fontFamily="monospace">{item.fallback?.text || '?'}</text>
        </svg>
      ) : (
        <img
          src={item.src} width="36" height="36" alt={item.name}
          onError={() => setErr(true)}
          style={{
            display: 'block',
            filter: item.invert ? 'invert(0.85) brightness(0.9)' : 'none',
          }}
        />
      )}
      <span style={{
        fontFamily: 'var(--mono)',
        fontSize: 8.5,
        letterSpacing: '0.6px',
        color: 'var(--text-muted)',
        textTransform: 'uppercase',
        textAlign: 'center',
        lineHeight: 1.3,
        maxWidth: 64,
      }}>{item.name}</span>
    </div>
  );
}

export default function Skills({ dark }) {
  const [animate, setAnimate] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setAnimate(true); },
      { threshold: 0.08 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  // flat index for staggered delay across all items
  let globalIndex = 0;

  return (
    <section id="skills" ref={ref}>
      <div className="inn">
        <div className="shdr reveal">
          <div className="sn2">02 / Skills</div>
          <h2 className="st">THE<br />ARSENAL</h2>
          <div className="sl2" />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '2.8rem' }}>
          {SKILLS.map((group) => (
            <div key={group.category}>
              {/* Category label */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                marginBottom: '1rem',
                opacity: animate ? 1 : 0,
                transition: 'opacity 0.4s ease',
              }}>
                <span style={{
                  fontFamily: 'var(--mono)',
                  fontSize: 8,
                  letterSpacing: '2.5px',
                  color: 'var(--accent-color)',
                  textTransform: 'uppercase',
                  whiteSpace: 'nowrap',
                }}>{group.category}</span>
                <div style={{
                  flex: 1,
                  height: 1,
                  background: 'var(--border-color)',
                }} />
                <span style={{
                  fontFamily: 'var(--mono)',
                  fontSize: 7.5,
                  color: 'var(--text-muted)',
                  letterSpacing: '1px',
                }}>{group.items.length}</span>
              </div>

              {/* Logo row */}
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '0.25rem',
              }}>
                {group.items.map((item) => {
                  const delay = globalIndex * 0.05;
                  globalIndex++;
                  return (
                    <SkillItem
                      key={`${group.category}-${item.name}`}
                      item={item}
                      animate={animate}
                      delay={delay}
                      dark={dark}
                    />
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* Total count footer */}
        <div style={{
          marginTop: '3rem',
          paddingTop: '1.5rem',
          borderTop: '1px solid var(--border-color)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          opacity: animate ? 0.45 : 0,
          transition: 'opacity 0.6s ease 0.5s',
        }}>
          <span style={{ fontFamily: 'var(--mono)', fontSize: 8, letterSpacing: '1.5px', color: 'var(--text-muted)', textTransform: 'uppercase' }}>
            {SKILLS.reduce((acc, g) => acc + g.items.length, 0)} technologies across {SKILLS.length} domains
          </span>
          <span style={{ fontFamily: 'var(--mono)', fontSize: 8, letterSpacing: '1.5px', color: 'var(--text-muted)', textTransform: 'uppercase' }}>
            2022 — present
          </span>
        </div>
      </div>

      <style>{`
        @media(max-width:640px){
          #skills .inn { padding: 0 1rem; }
        }
      `}</style>
    </section>
  );
}